import { render, staticRenderFns } from "./PerformanceReport.vue?vue&type=template&id=51a58b58&"
import script from "./PerformanceReport.vue?vue&type=script&lang=js&"
export * from "./PerformanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports